/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionDownload
 */
export interface SubmissionDownload {
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionDownload
     */
    readonly ready: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDownload
     */
    readonly url: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionDownload
     */
    readonly reason: string;
}

/**
 * Check if a given object implements the SubmissionDownload interface.
 */
export function instanceOfSubmissionDownload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function SubmissionDownloadFromJSON(json: any): SubmissionDownload {
    return SubmissionDownloadFromJSONTyped(json, false);
}

export function SubmissionDownloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionDownload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ready': json['ready'],
        'url': json['url'],
        'reason': json['reason'],
    };
}

export function SubmissionDownloadToJSON(value?: SubmissionDownload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

